export const sendRequestToConnector = async (payload) => {
  return new Promise((resolve, reject) => {
    const requestId = Math.random().toString(36).substring(7);
    const handler = (event) => {
      if (event.source !== window || event.data.direction !== 'from-extension') return;
      if (event.data.payload && event.data.payload.requestId && event.data.payload.requestId === requestId) {
        window.removeEventListener('message', handler);
        if (event.data.payload.error) {
          const networkErrors = [
            'Failed to fetch',
            'NetworkError',
            'Network request failed',
            'TypeError: Failed to fetch',
            'ERR_INTERNET_DISCONNECTED',
            'ERR_NETWORK_CHANGED'
          ];
          
          const isNetworkError = networkErrors.some(error => 
            event.data.payload.error.includes(error)
          );
          
          if (isNetworkError) {
            reject(new Error('no connection'));
          } else {
            reject(new Error(event.data.payload.error));
          }
        } else {
          resolve(event.data.payload);
        }
      }
    };
    window.addEventListener('message', handler);
    window.postMessage({
      direction: 'to-extension',
      payload: {
        ...payload,
        requestId
      }
    }, '*');
    setTimeout(() => {
      window.removeEventListener('message', handler);
      reject(new Error('Extension response timeout'));
    }, 15000);
  });
};